/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Changes_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Changes synced successfully." |
*
* @param {Sync_Changes_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_success_toast = /** @type {((inputs?: Sync_Changes_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifications synchronisees avec succes.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen erfolgreich synchronisiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifiche sincronizzate correttamente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменения успешно синхронизированы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los cambios se sincronizaron correctamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更改已成功同步。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変更が正常に同期されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिवर्तन सफलतापूर्वक सिंक हो गए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alterações sincronizadas com sucesso.")
	return /** @type {LocalizedString} */ ("Changes synced successfully.")
});